import React from "react"
import PropTypes from "prop-types"
import { NumericFormat } from "react-number-format"
import { TextField } from "@mui/material"

const ExpensesInput = ({
  value,
  onChange = () => {},
  onBlur = () => {},
  suffix = "€",
  readOnly = false,
  disabled = false,
  size = "medium",
  InputProps = {},
  sx = {},
  decimalScale = 2,
  fixedDecimalScale = true,
  label = "",
  allowNegative = false,
}) => {
  const baseSx = { backgroundColor: "white", ...sx }
  const isNegative = Number(value) < 0
  const materialUITextFieldProps = {
    variant: "outlined",
    fullWidth: true,
    label,
    InputProps: suffix
      ? {
          ...InputProps,
          endAdornment: suffix,
          inputProps: {
            ...(InputProps.inputProps || {}),
            style: isNegative ? { color: "red" } : {},
          },
        }
      : {
          ...InputProps,
          inputProps: {
            ...(InputProps.inputProps || {}),
            style: isNegative ? { color: "red" } : {},
          },
        },
    sx:
      size === "small"
        ? {
            width: 90,
            "& .MuiInputBase-root": { height: 28, fontSize: "0.85rem" },
            ...baseSx,
          }
        : { "& .MuiInputBase-root": { height: 42 }, ...baseSx },
    size,
  }

  const handleClick = e => {
    e.stopPropagation()
    if (materialUITextFieldProps.onClick) {
      materialUITextFieldProps.onClick(e)
    }
  }

  return (
    <NumericFormat
      disabled={disabled}
      value={value}
      thousandSeparator={false}
      decimalSeparator="."
      customInput={TextField}
      allowNegative={allowNegative}
      decimalScale={decimalScale}
      fixedDecimalScale={fixedDecimalScale}
      locale="es-ES"
      {...materialUITextFieldProps}
      isAllowed={values => {
        if (readOnly) return false
        return true
      }}
      onValueChange={onChange}
      onBlur={e => {
        if (e.target.value === "") {
          onChange(0)
        }
      }}
      onClick={handleClick}
    />
  )
}

ExpensesInput.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  onChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func,
  suffix: PropTypes.string,
  disabled: PropTypes.bool,
  readOnly: PropTypes.bool,
  variant: PropTypes.string,
  size: PropTypes.string,
  InputProps: PropTypes.object,
  sx: PropTypes.object,
  decimalScale: PropTypes.number,
  fixedDecimalScale: PropTypes.bool,
  label: PropTypes.string,
  allowNegative: PropTypes.bool,
}

ExpensesInput.defaultProps = {
  allowNegative: false,
}

export default ExpensesInput
